module.exports = __webpack_public_path__ + "assets/xinxi.0a1cca662678480a842c538b250e7a8e.png";